interface QuerySettings {
  value: string;
  results_per_page: number;
  results_page: number;
  type?: string;
}
/* jscpd:ignore-start */

export const searchRecipesForResults = async (
  keyword: string,
  type: string,
  page: number,
  results_per_page: number = 100,
) => {
  let querySettings: QuerySettings = {
    value: keyword,
    results_per_page: results_per_page,
    results_page: page || 1,
  };

  if (type) {
    querySettings = { ...querySettings, type: type };
  }

  const entries = Object.entries(querySettings);
  const queryForAPI = entries
    .map(([key, value]) => {
      return value ? `${key}=${value}` : "";
    })
    .filter((el) => {
      return el !== "";
    })
    .join("&");

  const encodedQuery = encodeURIComponent(queryForAPI);

  try {
    const url = `/api/recipes?type=search&searchQuery=${encodedQuery}`;
    const res = await fetch(`${url}`);
    return (await res?.json()) || null;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const searchPagesForResults = async (
  keyword: string,
  locale: string | undefined = "de",
) => {
  try {
    const res = await fetch(
      `/api/searchPages?keywords=${keyword}${
        locale !== "de" ? `&locale=${locale}` : ""
      }`,
    );
    return (await res?.json()) || null;
  } catch (e) {
    console.error(e);
    return null;
  }
};
/* jscpd:ignore-end */
